import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@assets/images/logo.svg'


const _hoisted_1 = { class: "Modal__body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "Modal__logo",
  src: _imports_0
}, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "Modal__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "Modal",
        testId: "background",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("div", {
            class: "Modal__close",
            testId: "closeIcon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, null, 512 /* NEED_PATCH */), [
            [_vShow, !_ctx.noCloseIcon]
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.isOpen]
      ])
    ]),
    _: 3 /* FORWARDED */
  }))
}